import React, { useEffect, useRef, useState } from 'react';
import { Input } from './ui/input';

export function parseList(text) {
  return String(text || '')
    .split(',')
    .map((item) => item.trim())
    .filter(Boolean);
}

/*
  A comma-separated list typed as plain text (countries, cities, ISPs...).
  It keeps exactly what the person types, spaces and a trailing comma
  included, and reports the parsed list through onChange(list). The text is
  re-read from value only when the list changes from outside.
*/
export default function ListInput({ value, onChange, ...props }) {
  const list = Array.isArray(value) ? value : parseList(value);
  const key = list.join('\u0000');
  const [text, setText] = useState(list.join(', '));
  const lastKey = useRef(key);

  useEffect(() => {
    if (key !== lastKey.current) {
      lastKey.current = key;
      setText(key ? key.split('\u0000').join(', ') : '');
    }
  }, [key]);

  return (
    <Input
      {...props}
      value={text}
      onChange={(e) => {
        const next = parseList(e.target.value);
        lastKey.current = next.join('\u0000');
        setText(e.target.value);
        onChange(next);
      }}
    />
  );
}
